// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Mis solicitudes',
    path: '/tickets',
    icon: icon('li'),
    role: ['Usuario','Soporte','Administrador','Administrador Tickets']
  },
  {
    title: 'Admin tickets',
    path: '/ticketsAdmin',
    icon: icon('li'),
    role: ['Administrador Tickets','Soporte'],
  },
  {
    title: 'Categoría de tickets',
    path: '/ticketsCategory',
    icon: icon('li'),
    role: ['Administrador Tickets','Soporte'],
    permissions: []
  },
  {
    title: 'Reportes tickets',
    path: '/ticketsReport',
    icon: icon('li'),
    role: ['Administrador Tickets','Soporte'],
  },
  {
    title: 'Usuarios',
    path: '/users',
    icon: icon('li'),
    role: ['Administrador'],
    permissions: []
  },
  {
    title: 'Bancos',
    path: '/checkbookAccounts',
    icon: icon('li'),
    role: ['Imprimir Cheques']
  },
  {
    title: 'Imprimir Cheque',
    path: '/checkbooks',
    icon: icon('li'),
    role: ['Imprimir Cheques']
  },
  {
    title: 'Invitaciones',
    path: '/invitationsPage',
    icon: icon('li'),
    role: ['Personalities Admin']
  },
  {
    title: 'Personalidades',
    path: '/personalities',
    icon: icon('li'),
    role: ['Personalities']
  },
  {
    title: 'Instituaciones Personalidades',
    path: '/personalitiesInstitutions',
    icon: icon('li'),
    role: ['Personalities Admin']
  },
  {
    title: 'Inventario',
    path: '/inventory',
    icon: icon('li'),
    role: ['InventoryAdmin']
  },
  {
    title: 'Concurso',
    path: '/enrollment',
    icon: icon('li'),
    role: ['Enrollment']
  },
  {
    title: 'Numera',
    path: '/communications',
    icon: icon('li'),
    role: ['Communications']
  },
  {
    title: 'Smtp',
    path: '/smtp',
    icon: icon('li'),
    role: ['Administrador']
  },
  {
    title: 'Capacitaciones y Rec.',
    path: '/capacitaciones',
    icon: icon('li'),
    role: ['Solicitudes Cap y Rec.']
  },
  {
    title: 'App Móvil',
    path: '/appMovil',
    icon: icon('li'),
    role: ['App Movil']
  }
];

export default navConfig;
